import { Card, Container, Stack, Typography } from "@mui/material";
import { updateActivitiesEmailTemplate } from "backend/api/emailing";
import Locker from "components/activities/Locker";
import { EmailTemplateAssignmentTable } from "components/emailing/EmailTemplateAssignmentTable/EmailTemplateAssignmentTable";
import { toastEmitter } from "helpers/helpers";
import { useError } from "hooks/useError";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { NewActivityEmailTemplate } from "types/emailTemplate.type";

export function AssignEmailTemplatesPage() {
  const [isLocked, setIsLocked] = useState(true);
  const { t } = useTranslation("emailing");
  const { onError } = useError(t, "assignEmail.saveError");

  const { mutate, isLoading } = useMutation({
    mutationFn: (assignments: NewActivityEmailTemplate[]) =>
      updateActivitiesEmailTemplate({ assignments }),
    onSuccess: () => {
      toastEmitter(t("assignEmail.saveSuccess"), "success");
    },
    onError,
  });

  const toggleLocker = () => {
    setIsLocked((p) => !p);
  };

  return (
    <Container maxWidth={false}>
      <Card
        sx={{
          position: "relative",
        }}
      >
        <Locker isOpen={!isLocked} onClick={toggleLocker} />
        <Stack py={3} gap={3}>
          <Typography
            variant="h2"
            fontSize={"1.5rem"}
            fontWeight={"bold"}
            color={"secondary.dark"}
            textTransform={"uppercase"}
            textAlign={"center"}
          >
            {t("assignEmail.title")}
          </Typography>
          <EmailTemplateAssignmentTable
            isSubmitting={isLoading}
            isDisabled={isLocked}
            onSubmit={(value) => mutate(value)}
          />
        </Stack>
      </Card>
    </Container>
  );
}
